import TKCustomElementFactory from './tk.custom.element.factory';

enum Size {
    MEDIUM = 'sizeM',
    SMALL = 'sizeS'
}

interface InputTypeClasses {
    sizeS: string;
    sizeM: string;
    labelLeft: string;
    noLabel: string;
}

export default class TKStyleguideFormHelper extends TKCustomElementFactory {
    defaultSizeKey: string;
    inputSelector: string;
    inputTypeDropdownSelector: string;
    inputTypeClasses: InputTypeClasses;
    typeDropDown: HTMLSelectElement | undefined;

    constructor() {
        super();

        this.defaultSizeKey = Size.MEDIUM;
        this.inputSelector = this.getAttribute('data-tk-input-selector')
            || 'tk-form-input';
        this.inputTypeDropdownSelector = 'data-input-type-dropdown';
        this.typeDropDown = this.querySelector<HTMLSelectElement>(`[${this.inputTypeDropdownSelector}]`)
            || undefined;
        this.inputTypeClasses = {
            sizeS: `${this.inputSelector}--size-s`,
            sizeM: '',
            labelLeft: `${this.inputSelector}--label-left`,
            noLabel: `${this.inputSelector}--label-none`,
        };
    }

    connectedCallback(): void {
        this.registerClickListener();
        this.removeUnusedInputClasses();
    }

    registerClickListener() {
        if (!this.typeDropDown) throw new Error('Missing type drop down');

        const onChange = this.onInputTypeChanged.bind(this, this.typeDropDown);
        this.pushListener({ event: 'change', element: this.typeDropDown, action: onChange });
    }

    onInputTypeChanged(inputTypeDropdown: HTMLSelectElement) {
        const currentType = inputTypeDropdown.value;

        const inputElements = this.querySelectorAll(`.${this.inputSelector}`);

        if (!inputElements) throw new Error('No input elements found');

        inputElements.forEach((element) => {
            Object.keys(this.inputTypeClasses).forEach((key) => {
                const isDefaultSizeKey = key === this.defaultSizeKey;
                const isCurrentType = key === currentType;
                const shouldAddClass = isCurrentType;

                if (!isDefaultSizeKey) {
                    element.classList.toggle(this.inputTypeClasses[key as keyof InputTypeClasses], shouldAddClass);
                }
            });
        });
    }

    removeUnusedInputClasses() {
        if (!this.typeDropDown) return;

        const availableOptions = [...this.typeDropDown.options].map((optionObj) => optionObj.value);

        Object.keys(this.inputTypeClasses).forEach((possibleOption: string) => {
            if (!availableOptions.includes(possibleOption)) {
                delete this.inputTypeClasses[possibleOption as keyof InputTypeClasses];
            }
        });
    }
}
